<script setup lang="ts">
defineProps<{
  eyebrow?: string
  title:    string
  lead?:    string
  ctaPrimaryLabel?:    string
  ctaPrimaryHref?:     string
  ctaSecondaryLabel?:  string
  ctaSecondaryHref?:   string
}>()
</script>

<template>
  <section class="rod-section relative pt-32 lg:pt-40 overflow-hidden">
    <div class="rod-aurora" />
    <div class="absolute inset-0 rod-grid-bg" />

    <div class="rod-container relative">
      <div class="max-w-4xl" data-reveal>
        <div v-if="eyebrow" class="rod-eyebrow mb-6">✦ {{ eyebrow }}</div>

        <h1 class="rod-h1 mb-6" v-html="title" />

        <p v-if="lead" class="text-lg lg:text-xl text-[var(--color-text-muted)] max-w-3xl mb-10 leading-relaxed">
          {{ lead }}
        </p>

        <div v-if="ctaPrimaryLabel || ctaSecondaryLabel" class="flex flex-wrap gap-4">
          <a v-if="ctaPrimaryLabel" :href="ctaPrimaryHref || '#cta'" class="rod-btn-primary">
            {{ ctaPrimaryLabel }}
            <span aria-hidden="true">→</span>
          </a>
          <a v-if="ctaSecondaryLabel" :href="ctaSecondaryHref || '#how'" class="rod-btn-secondary">
            {{ ctaSecondaryLabel }}
          </a>
        </div>
      </div>
    </div>
  </section>
</template>
